import React, { Component } from "react";
import { Select } from "antd";
import {
  displayControlType,
  punishBusinessLineSearchType,
} from "../../utils/interfaceType";
import styles from "./index.less";

interface Props {
  displayControl: displayControlType;
  menuList: any;
  getConditionId: (conditionId: string | number) => void;
  type: string;
  defaultValue: string;
}
interface State {}
class ConditionMenu extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  /**
   * @description 获取业务线，调用父组件查询方法
   *
   **/
  handleSelect = (value, punishBusinessLine) => {
    const { getConditionId } = this.props;
    getConditionId(punishBusinessLine.key);
  };

  render() {
    const { menuList, defaultValue } = this.props;

    return (
      <div className={styles.conditionMenu}>
        <Select
          style={{ width: "226px" }}
          defaultValue={defaultValue}
          onSelect={this.handleSelect}
        >
          <Select.Option value="不限" key="">
            不限
          </Select.Option>
          {menuList &&
            menuList.map((item: punishBusinessLineSearchType) => {
              return (
                <Select.Option value={item.name} key={item.id}>
                  {item.name}
                </Select.Option>
              );
            })}
        </Select>
      </div>
    );
  }
}

export default ConditionMenu;
